import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';
import { Link } from 'react-router-dom';
/* Material UI Components */
import GetAppIcon from '@material-ui/icons/GetApp';
import Tooltip from '@material-ui/core/Tooltip';

import { fetchReport } from '../ReportLoader/actions';
import { getStaffId } from '../../../BidSession/helpers';
import CardHead from './../../../../components/CardHead';
import { REPORTS } from './../../../../settings/settings.json';
import MIMES from '../../../../data/constants/mimes';
import { useLanguage } from '../../../../context/LanguageContext';

import './styles.scss';

class ReportsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      downloadCounts: {}
    };
  }

  getFileExtension = (contentType) => {
    if (MIMES[contentType] !== undefined) {
      return `.${MIMES[contentType].extension}`;
    }
    return '';
  }

  handleChangePage = (e) => {
    this.setState({ activePage: e });
  }

  handleClickPagination = (e) => {
    console.log(e);
  }

  handleDownload = async (report, event) => {
    event.preventDefault();
    event.stopPropagation();

    let objectUrl = null;
    try {
      const staffId = getStaffId();
      const response = await fetchReport(report.uniqueIdentifier, staffId);
      const contentType = response.data.type;
      const fileExtension = this.getFileExtension(contentType);

      const blob = new Blob([response.data], { type: contentType });
      objectUrl = URL.createObjectURL(blob);

      const currentCount = this.state.downloadCounts[report.uniqueIdentifier] || 0;
      const fileName = currentCount === 0
        ? `${report.title}${fileExtension}`
        : `${report.title}(${currentCount + 1})${fileExtension}`;

      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = fileName;
      link.click();

      this.setState(prevState => ({
        downloadCounts: {
          ...prevState.downloadCounts,
          [report.uniqueIdentifier]: currentCount + 1
        }
      }));
    } catch (error) {
      alert(`${REPORTS.DOWNLOAD_ERROR}: ${error.message || error}`);
    } finally {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    }
  }

  renderIcon = (icon, title, onClick) => (
    <Tooltip title={title} placement="top">
      <div onClick={onClick}>
        {React.cloneElement(icon, { style: { pointerEvents: 'none' } })}
      </div>
    </Tooltip>
  )

  render() {
    let reports = this.props.reportsList;
    let reportsList = [];

    const to = REPORTS.ITEMS_PER_PAGE * this.state.activePage;
    const from = to - REPORTS.ITEMS_PER_PAGE;

    if (reports.constructor === Array) {
      reports = reports.slice(from, to);
      reports.forEach((report, i) => {
        reportsList.push(
          <Link
            key={report.uniqueIdentifier}
            target={'_blank'}
            rel="opener"
            style={{ textDecoration: 'none' }}
            to={`report-loader/${report.uniqueIdentifier}`}
          >
            <CardHead
              title={report.title}
              subtitle=""
              hasMenu={false}
              headClassName={i % 2 === 0 ? 'report-item bc-white' : 'report-item bc-trans'}
              rightElement={
                <div className="rightElement">
                  {this.renderIcon(
                    <i className="ion-ios-arrow-right" />,
                    REPORTS.VIEW,
                    null
                  )}
                  <div
                    className="download-wrapper"
                    onClick={e => {
                      e.stopPropagation();
                      this.handleDownload(report, e);
                    }}
                  >
                    <div className="download">
                      {this.renderIcon(
                        <GetAppIcon />,
                        REPORTS.DOWNLOAD,
                        null
                      )}
                    </div>
                  </div>
                </div>
              }
            />
          </Link>
        );
      });
    } else {
      reportsList = reports;
    }
    return (
      <div className="reports-container large-12 columns">
        <div className="reports-list">
          {reportsList}
        </div>
        {this.props.reportsList.length > REPORTS.ITEMS_PER_PAGE &&
          <div className="pagination-container large-12 columns">
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={REPORTS.ITEMS_PER_PAGE}
              totalItemsCount={this.props.reportsList.length}
              pageRangeDisplayed={REPORTS.PAGE_RANGE_DISPLAYED}
              onChange={this.handleChangePage}
              onClick={this.handleClickPagination}
              prevPageText={<i className="ion-ios-arrow-back arrow-pag" />}
              nextPageText={<i className="ion-ios-arrow-forward arrow-pag" />}
            />
          </div>
        }
      </div>
    );
  }
}

ReportsTable.defaultProps = {
  reportsList: [],
};
ReportsTable.propTypes = {
  reportsList: PropTypes.any,
};

function ReportsTableWrapper(props) {
  const { labels } = useLanguage();
  return <ReportsTable {...props} labels={labels} />;
}

export default ReportsTableWrapper;